import { useState } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import searchClient from 'bl/client/searchClient.bl';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './AddClientButton.module.scss';

// @tech-debt: Refactor component
export const AddClientButton = ({ onAddClient, buttonText }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  const [currentlyDisplayed, setCurrentlyDisplayed] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [clearBtn, setClearBtn] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [showSearchBtn, setShowSearchBtn] = useState(true);
  const clients = useSelector((state) => state.currentSalon.clientList);
  const displayedClients = useSelector((state) => state.checkout.data.clients);
  const { isDarkMode } = useTheme();

  const filteredClients = clients.filter((client) => !displayedClients.some((c) => c.id === client.id));

  const search = (event) => {
    const searchTerm = event.target.value;
    const resultList = searchClient({ text: searchTerm, list: filteredClients }).sort((b, a) => a.rank - parseFloat(b.rank));
    setSearchTerm(searchTerm);
    setSelectedClient(null);
    setCurrentlyDisplayed(resultList);
    setClearBtn(true);
  };

  const select = (client) => {
    setSearchTerm(client.user_name);
    setCurrentlyDisplayed([]);
    setSelectedClient(client);
  };

  const add = () => {
    if (selectedClient) {
      onAddClient(selectedClient);
      setSearchTerm('');
      setSelectedClient(null);
      setShowSearch(false);
      setShowSearchBtn(true);
    }
  };

  const clearClient = () => setSearchTerm('');

  const showInputSearch = () => {
    setShowSearch(true);
    setShowSearchBtn(false);
  };

  const noResults = !selectedClient && currentlyDisplayed.length === 0 && searchTerm.length > 0;
  const hasSearchQuery = searchTerm.length > 0;
  const hasResults = currentlyDisplayed.length > 0;

  return (
    <div
      data-bem="AddClientButton"
      data-testid="AddClientButton"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.searchClient}>
        {showSearchBtn && (
          <div data-testid="AddClientButton__showInput" className={CN.addClientButton} role="button" tabIndex={0} onClick={showInputSearch}>
            {buttonText}
          </div>
        )}
        {showSearch && (
          <div className={CN.addClient}>
            <input
              type="text"
              data-testid="AddClientButton__inputSearch"
              id="client-search"
              className={CN.inputSearch}
              placeholder={t('checkout.checkoutTitle.searchPlaceholder')}
              value={searchTerm}
              onChange={search}
              onBlur={add()}
              autoComplete="off"
              autoFocus
            />
            {clearBtn && hasSearchQuery && <span data-testid="AddClientButton__clearSearchQuery" onClick={clearClient} role="button" tabIndex={0} className={CN.clearSearchBtn} />}
            <div className={CN.dropdownContainer}>
              {noResults && (
                <div data-testid="AddClientButton__noResults" className={CN.dropdownSuggestions}>
                  <span className={CN.noResults}>{t('common.messages.noResults')}</span>
                </div>
              )}
              {hasResults && hasSearchQuery && (
                <div data-testid="AddClientButton__results-dropdown" className={CN.dropdown}>
                  {currentlyDisplayed.map((client) => (
                    <div id="chk-results-item" className={CN.item} key={client.id} onClick={() => select(client)} role="menuitem" tabIndex="0">
                      {client.user_name}
                      {client.has_appointment_today && <div>{t('checkout.checkoutTitle.bookingToday')}</div>}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
